import { render, staticRenderFns } from "./PCheckBox.vue?vue&type=template&id=50b617c1&"
import script from "./PCheckBox.vue?vue&type=script&lang=js&"
export * from "./PCheckBox.vue?vue&type=script&lang=js&"
import style0 from "./PCheckBox.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports